import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-144">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/eiLQUBrEWx37Vo3ypi9Zbu/pasted-image.jpg')",
      filter: 'brightness(0.5)'
    }} data-id="element-145" />
      <div className="container mx-auto px-4 z-10 text-center" data-id="element-146">
        <div className="mt-20 sm:mt-8" data-id="element-147">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6bvXLLLbgQPyGsuTNy77Kh/Screenshot_2025-04-12_at_11.48.16_AM-removebg-preview.png" alt="Chicago Kush Logo" className="h-32 sm:h-52 mx-auto mb-12 sm:mb-8 animate-fadeIn" data-id="element-148" />
        </div>
        <h1 className="font-display italic text-4xl sm:text-6xl font-bold mb-6 text-white leading-tight" data-id="element-149">
          Premium Quality <span className="text-red-500" data-id="element-150">Cannabis</span>
        </h1>
        <p className="font-body text-xl text-gray-300 max-w-2xl mx-auto mb-10 italic" data-id="element-151">
          Experience the finest selection of premium cannabis products,
          carefully crafted for the connoisseur.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-152">
          <a href="#products" className="font-display italic bg-red-600 hover:bg-red-700 text-white py-3 px-8 rounded-full transition duration-300" data-id="element-153">
            Explore Products
          </a>
          <a href="#about" className="font-display italic bg-transparent hover:bg-white/10 text-white border border-white py-3 px-8 rounded-full transition duration-300" data-id="element-154">
            Learn More
          </a>
        </div>
        <div className="flex justify-center" data-id="element-155">
          <a href="#products" className="text-white animate-bounce" data-id="element-156">
            <ArrowDownIcon size={32} data-id="element-157" />
          </a>
        </div>
      </div>
    </section>;
};